import type { ReactNode } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import clsx from "../../../modules/helpers/clsx";
import { useFocusable } from "../../../modules/spatialNavigation";
import IconComponent from "../../shared/icon/IconComponent";
import * as styles from "./styles.module.scss";

interface IProps {
  route?: string;
  children?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  iconName?: string;
  title?: string;
  withBulletTrigger?: boolean;
}

const MenuItemContent = (props: IProps & { focused: boolean }) => {
  const location = useLocation();
  return (
    <>
      {props.iconName && (
        <IconComponent
          fontSize="2rem"
          bold={props.focused}
          class="icon"
          type={location.pathname === props.route ? "fill" : "outlined"}
          name={props.iconName}
        />
      )}
      {props.withBulletTrigger && (
        <span className={styles.bulletTrigger}>
          <span className={styles.bulletTriggerInner} />
        </span>
      )}
      {props.children && <div>{props.children}</div>}
      <div>
        <span className={`${styles.listItemTitle} ${props.focused ? styles.listItemTitleFocused : ""}`}>
          {props.title}
        </span>
      </div>
    </>
  );
};

const MenuItem = (props: IProps) => {
  const history = useHistory();
  const { ref, focused } = useFocusable({
    onEnterPress: (e) => {
      props.onClick && !props.disabled ? props.onClick() : history.push(props.route);
    },
    focusKey: props.route,
  });
  if (props.route) {
    return (
      <NavLink
        to={props.route}
        exact
        activeClassName={styles.activePaddingMenuItem}
        className={clsx({
          [styles.paddingMenuItem]: true,
          [styles.focused]: focused,
        })}
        ref={ref}
        onClick={() => !!props.onClick && !props.disabled && props.onClick()}
      >
        <MenuItemContent {...props} focused={focused} />
      </NavLink>
    );
  } else {
    return (
      <button
        className={clsx({
          [styles.paddingMenuItem]: true,
          [styles.buttonItem]: true,
          [styles.focused]: focused,
        })}
        ref={ref}
        onClick={() => props.onClick && !props.disabled && props.onClick()}
      >
        <span className={styles.buttonInner}>
          <MenuItemContent {...props} focused={focused} />
        </span>
      </button>
    );
  }
};
export default MenuItem;
